import React from "react";

const Divider: React.FC = () => {
  return <hr className="border-t-2 border-gray-100 my-2  mx-2" />;
};

export default Divider;
